import Rollbar from 'rollbar';

const environment = process.env.FLOW_ENV === 'production' ? 'production' : 'development';

let rollbar: Rollbar;

/**
 * Returns instance of Rollbar with the appropriate configuration for this application.
 */
function createRollbar(): Rollbar {
  return new Rollbar({
    accessToken: '456aa1f0f4034b5aa26181c79f080e7a', // This is a token to identify the app, not private
    captureUncaught: true,
    captureUnhandledRejections: true,
    captureIp: 'anonymize',
    enabled: environment === 'production',
    payload: {
      environment,
    },
    scrubTelemetryInputs: true,
    verbose: true,
  });
}

/**
 * Returns instance of the rollbar object. Enables 'singleton' behavior by returning existing
 * instance if defined already.
 */
export default function getRollbarInstance(): Rollbar {
  if (rollbar) {
    return rollbar;
  }

  rollbar = createRollbar();
  return rollbar;
}
